<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<div class="d-flex align-center mr-2" style="flex: 1;max-width: 120px;">
				<!-- <v-select
					v-model="sort_by"
					:items="sortByItems"
					:menu-props="{ top: true, offsetY: true }"
					item-text="text"
					item-value="value"
					label="Ordenar Por"
					class="custom-height-search custom-height-calendar"
					outlined
					dense
					required
				>
				</v-select> -->
				<v-menu v-model="sortByMenu" :offset-y="true" :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn text class="table-header-button d-flex flex-row pa-0 justify-start" block style="height: auto;"
							v-bind="attrs"
							v-on="on">
							<p class="mb-0 font-weight-bold body-2 text-capitalize">Ordenar Por</p>
							<v-icon small class="ml-2">mdi-sort</v-icon>
						</v-btn>
					</template>

					<v-list dense class="filter-selector-list">
						<v-list-item dense style="min-height: auto;">
							<div style="width: 100%" class="mb-2">
								<p class="mb-0 font-weight-bold caption text-primary-color text-capitalize">Ordenar Por:</p>
								<v-divider></v-divider>
							</div>
						</v-list-item>
						<v-list-item-group v-model="sort_by">
							<v-list-item
								style="min-height: auto;"
								v-for="(item, index) in sortByItems"
								:key="index"
								:value="item.value">
								<template v-slot:default="{ active }">
									<v-list-item-title class="my-0 d-flex flex-row align-center">
										<v-checkbox
											dense
											hide-details
											color="#959595"
											class="caption my-0 py-0"
											:input-value="active"></v-checkbox>
										<p class="mb-0 caption">{{item.text}}</p>
									</v-list-item-title>
								</template>
							</v-list-item>
						</v-list-item-group>
						<v-divider class="my-1"></v-divider>
						<v-list-item-group v-model="sort_by_direction">
							<v-list-item
								style="min-height: auto;"
								v-for="(item, index) in sortByDirection"
								:key="index"
								:value="item.value">
								<template v-slot:default="{ active }">
									<v-list-item-title class="my-0 d-flex flex-row align-center">
										<v-checkbox
											dense
											hide-details
											color="#959595"
											class="caption my-0 py-0"
											:input-value="active"></v-checkbox>
										<p class="mb-0 caption">{{item.text}}</p>
									</v-list-item-title>
								</template>
							</v-list-item>
						</v-list-item-group>
						<v-list-item dense style="min-height: auto;">
							<v-btn x-small block color="#959595" dark class="mt-2" @click="reloadInfo()">
								<p class="mb-0 caption">Aplicar Orden</p>
							</v-btn>
						</v-list-item>
					</v-list>
				</v-menu>
			</div>
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="$store.state.contracts.loadingCompanyClients"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="usersCount"
				:loading-info="loadingUsers"
			/>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				:headers="headers"
				:items="users"
				:server-items-length="usersCount"
				:search="search"
				item-key="id"
				:loading="loadingUsers"
				:options.sync="options"
				class="crm-table"
				loading-text="Cargando datos..."
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:item.client="{ item }">
					<div class="d-flex align-center">
						<v-avatar
							size="30"
						>
							<img :src="item.profile?.avatar" class="user-avatar" v-if="item.profile?.avatar"/>
							<v-icon v-else class="user-avatar icon" color="#524D4D" x-large>mdi-account</v-icon>
						</v-avatar>
						<div class="d-flex flex-column flex-grow-1">
							<p class="ml-2 mb-0 font-weight-bold">{{ item.profile?.name }} {{ item.profile?.lastname }} {{ item.profile?.second_lastname }}</p>
							<p class="ml-2 mb-0 caption">{{ item.email }} | {{ item.profile?.phone }}</p>
						</div>
					</div>
				</template>
				<template v-slot:item.actual_status="{ item }">
					<div class="my-1">
						<div class="d-flex align-center justify-space-between">
							<v-chip
								:color="accreditationStatusColor(item.accreditation?.last_history?.status)"
								label
								outlined
								small
								class="px-1 mr-2"
							>
								<b>{{ accreditationStatus(item.accreditation?.last_history?.status) }}</b>
							</v-chip>
							<v-menu offset-y>
								<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
										<v-tooltip bottom>
											<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
												<v-btn
													depressed
													color="#959595"
													dark
													icon
													small
													v-bind="{ ...tooltipAttrs, ...menuAttrs }"
													v-on="{ ...tooltipOn, ...menuOn }"
												>
													<v-icon small>mdi-clipboard-text-clock-outline</v-icon>
												</v-btn>
											</template>
											<span>Historial de cambios en solicitud</span>
										</v-tooltip>
								</template>
								<v-list dense class="py-0 white">
									<v-list-item dense class="mb-0" style="min-height: 25px; background: #959595;">
										<div>
											<p class="caption mb-0 font-weight-bold white--text">Historial de cambios en solicitud</p>
										</div>
									</v-list-item>
									<v-list-item dense class="my-0 py-0" style="min-height: 25px;">
										<div class="d-flex justify-space-between align-center flex-grow-1">
											<p class="caption mb-0 text--disabled" style="width: 90px;">Estado</p>
											<p class="caption mb-0 text--disabled" style="width: 90px;">Fecha</p>
											<p class="caption mb-0 text--disabled text-end" style="width: 250px;">Responsable</p>
										</div>
									</v-list-item>
									<v-divider></v-divider>
									<v-list-item-group color="#524D4D" style="max-height: 350px;overflow-y:scroll;">
										<v-list-item
											v-for="(acc, index) in item.accreditation?.history"
											:key="'ctstatus-'+index"
											dense
											style="min-width: 350px;"
											class="white"
										>
											<v-list-item-title dense>
												<div class="d-flex justify-space-between align-center item-background-hover">
													<div class="d-flex align-center justify-space-between caption" style="width: 90px;">
														<v-chip
															:color="accreditationStatusColor(acc.status)"
															label
															outlined
															small
															class="px-1"
														>
															<b>{{ accreditationStatus(acc.status) }}</b>
														</v-chip>
													</div>
													<div class="d-flex justify-end caption" style="width: 90px;">
														<p class="mb-0 caption text-end">{{acc.created_at | toDateTime}}</p>
													</div>
													<div class="d-flex justify-end caption" style="width: 250px;">
														<p class="mb-0 caption text-end">{{ acc.company_user?.profile?.name + ' ' + acc.company_user?.profile?.lastname + ' ' + acc.company_user?.profile?.second_lastname }}</p>
													</div>
												</div>
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
						<p class="mt-1 mb-0" v-if="item.accreditation?.last_history">Modificado: <b>{{ item.accreditation?.last_history?.company_user?.profile?.name }} {{ item.accreditation?.last_history?.company_user?.profile?.lastname }} {{ item.accreditation?.last_history?.company_user?.profile?.second_lastname }} | {{ item.accreditation?.last_history?.created_at | toDate }}</b></p>
					</div>
				</template>
				<template v-slot:item.message="{ item }">
					<div class="my-1">
						<p class="mt-1 mb-0">{{ item.accreditation?.last_history?.detail }}</p>
					</div>
				</template>
				<template v-slot:item.actions="{ item }">
					<div class="d-flex align-center">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									color="#959595"
									dark
									icon
									small
									@click="changeAccreditationStatus(item)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon small>mdi-account-details-outline</v-icon>
								</v-btn>
							</template>
							<span>Visualiza el Detalle - Aprueba o Rechaza esta Solicitud</span>
						</v-tooltip>
					</div>
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.users.companyClientsCount"
				:loading-info="$store.state.users.loadingCompanyClients"
			/>
		</div> -->
  </v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import { getCompanyClientsAprovals } from '@/helpers/api/users'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'ClientsCompanyAprovals',
	components: {
		DataTablePagination,
	},
  data() {
    return {
			users: [],
			usersCount: 0,
			loadingUsers: false,
      search: '',
			selectedRowItem: null,
			searchInput: null,
			sortByMenu: false,
			sort_by: 'client',
			sort_by_direction: 'asc',
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [],
      },
			sortByItems: [
				{text: 'Cliente', value: 'client'},
				{text: 'Fecha Ingreso', value: 'created_at'},
				{text: 'Fecha Último Proyecto', value: 'last_project_date'}
			],
			sortByDirection: [
				{text: 'Ascendente', value: 'asc'},
				{text: 'Descendente', value: 'desc'}
			],
      headers: [
        { text: 'Cliente', value: 'client', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Estado Actual', value: 'actual_status', class: 'with-divider', cellClass: 'with-divider pr-0', width: 340, sortable: false },
        { text: 'Observación', value: 'message', class: 'with-divider', cellClass: 'with-divider', sortable: false },
        { text: 'Acciones', value: 'actions', align: 'center', width: 100, sortable: false },
      ],
    };
  },
  computed: {
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	watch: {
    options: {
      handler() {
				console.log(this.options)
				this.reloadInfo()
      },
      deep: true,
    },
		// sort_by(newValue){
		// 	if(newValue){
		// 		this.reloadInfo()
		// 	}
		// },
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.reloadInfo()
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_clients_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
    eventBus.$on('reloadInformation', this.reloadInfo)
	},
	beforeDestroy() {
		eventBus.$off('reloadInformation', this.reloadInfo)
	},
  methods: {
		accreditationStatus(status){
			if(status === 2){
				return 'Aprobado'
			}
			else if(status === 0){
				return 'Rechazado'
			}
			return 'Solicitado'
		},
		accreditationStatusColor(status){
			if(status === 2){
				return 'success'
			}
			else if(status === 0){
				return 'error'
			}
			return '#959595'
		},
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_clients_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.reloadInfo(this.searchInput)
		},
		async reloadInfo(search = null){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
				sort_by: this.sort_by,
				sort_by_direction: this.sort_by_direction
			}
			if(search){
				data = {search}
			}
			this.sortByMenu = false
			this.loadingUsers = true
			const users = await getCompanyClientsAprovals(data)
			if(users.code == 200){
				this.users = users.users
				this.usersCount = users.users_count
			}
			this.loadingUsers = false

		},
		toClientDetail(item){
			this.$router.push({ name: 'Client', params: { id: item.id } })
		},
    editUser(user) {
			const data = {...user, ...{user_id: user.id, client: true}}
			this.$store.commit('users/setNewUserModalEditing', data)
			this.$store.commit('users/setNewUserModal', true)
    },
		async changeAccreditationStatus(client){
			const currentStatus = client.accreditation && client.accreditation.status
			const newStatus = !currentStatus
			const data = {
				client,
				newStatus,
				status: true
			}
			this.$store.commit('users/setClientCompanyAprovalModal', data)
			// await setCompanyAccreditationUserStatus({
			// 	user_id: client.id,
			// 	status: newStatus
			// })
			// this.reloadInfo()
		},
  },
};
</script>

<style scoped>
.crm-table table tr td{
	font-size: 11px!important;
}
.crm-table.resizable .v-data-table__wrapper th,
.crm-table.resizable .v-data-table__wrapper td {
	border-right: 1px solid #cacaca;
}
</style>
<style>

.with-divider {
  border-right: 1px solid grey;
}
</style>